import { v4 as uuidv4 } from 'uuid';
import { ExampleNodeBuilder } from '../../builder/ExampleNodeBuilder';
import { LogicalType } from '../LogicalType';
import { Type } from '../Type';
export class ExampleObject extends Map {
    type = Type.Object;
    logicalType;
    tags;
    constructor(items = {}, logicalType, tags) {
        super(items instanceof Map ? items : Object.entries(items));
        this.logicalType = logicalType;
        this.tags = tags;
    }
    static new() {
        return new ExampleObjectBuilder();
    }
}
class ExampleObjectBuilder {
    logicalType;
    items = new Map();
    setLogicalType(logicalType) {
        this.logicalType =
            logicalType instanceof LogicalType
                ? logicalType
                : new LogicalType(logicalType, 1);
        return this;
    }
    addItem(key, value, build) {
        const builder = ExampleNodeBuilder.newSample(uuidv4(), value);
        if (build)
            build(builder);
        const node = builder.build();
        this.items.set(key, node);
        return this;
    }
    build() {
        return new ExampleObject(this.items, this.logicalType);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhhbXBsZU9iamVjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvb2JqZWN0L0V4YW1wbGVPYmplY3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEVBQUUsSUFBSSxNQUFNLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFFbkMsT0FBTyxFQUFFLGtCQUFrQixFQUFFLE1BQU0sa0NBQWtDLENBQUE7QUFFckUsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGdCQUFnQixDQUFBO0FBQzVDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxTQUFTLENBQUE7QUFHOUIsTUFBTSxPQUFPLGFBQ1gsU0FBUSxHQUFjO0lBR2IsSUFBSSxHQUFTLElBQUksQ0FBQyxNQUFNLENBQUE7SUFDeEIsV0FBVyxDQUFjO0lBQ3pCLElBQUksQ0FBVztJQUV4QixZQUNFLFFBQTRDLEVBQUUsRUFDOUMsV0FBeUIsRUFDekIsSUFBZTtRQUVmLEtBQUssQ0FBQyxLQUFLLFlBQVksR0FBRyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQTtRQUMzRCxJQUFJLENBQUMsV0FBVyxHQUFHLFdBQVcsQ0FBQTtRQUM5QixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQTtJQUNsQixDQUFDO0lBQ0QsTUFBTSxDQUFDLEdBQUc7UUFDUixPQUFPLElBQUksb0JBQW9CLEVBQUUsQ0FBQTtJQUNuQyxDQUFDO0NBQ0Y7QUFFRCxNQUFNLG9CQUFvQjtJQUNoQixXQUFXLENBQWM7SUFDekIsS0FBSyxHQUE2QixJQUFJLEdBQUcsRUFBRSxDQUFBO0lBRW5ELGNBQWMsQ0FBQyxXQUFpQztRQUM5QyxJQUFJLENBQUMsV0FBVztZQUNkLFdBQVcsWUFBWSxXQUFXO2dCQUNoQyxDQUFDLENBQUMsV0FBVztnQkFDYixDQUFDLENBQUMsSUFBSSxXQUFXLENBQUMsV0FBVyxFQUFFLENBQUMsQ0FBQyxDQUFBO1FBQ3JDLE9BQU8sSUFBSSxDQUFBO0lBQ2IsQ0FBQztJQUVELE9BQU8sQ0FDTCxHQUFXLEVBQ1gsS0FBbUIsRUFDbkIsS0FBMEM7UUFFMUMsTUFBTSxPQUFPLEdBQUcsa0JBQWtCLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxFQUFFLEtBQUssQ0FBQyxDQUFBO1FBQzdELElBQUksS0FBSztZQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQTtRQUN6QixNQUFNLElBQUksR0FBRyxPQUFPLENBQUMsS0FBSyxFQUFFLENBQUE7UUFDNUIsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLElBQUksQ0FBQyxDQUFBO1FBRXpCLE9BQU8sSUFBSSxDQUFBO0lBQ2IsQ0FBQztJQUVELEtBQUs7UUFDSCxPQUFPLElBQUksYUFBYSxDQUFDLElBQUksQ0FBQyxLQUFLLEVBQUUsSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUFBO0lBQ3hELENBQUM7Q0FDRiJ9